import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App.js'
import { initTelegramSync, initViewport } from './lib/telegram.js'
import { showFatal, installCrashReporter } from './lib/crash.js'
import './styles/global.css'

const root = document.getElementById('root')
if (!root) throw new Error('No #root element')

// Inside Telegram there is no console to open, so an uncaught error is a blank
// screen and nothing else. Paint it instead.
installCrashReporter()

try {
  /*
   * Synchronous, and it runs before the first render only because it sets the
   * theme — a flash of the wrong theme inside Telegram is the most obvious
   * "this is a web page" tell there is. Nothing here can block: anything that
   * needs the bridge to answer happens after the render.
   */
  initTelegramSync()

  createRoot(root).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  )

  initViewport()
} catch (err) {
  showFatal(err)
}
